import { Button, type ButtonProps } from '@direct-frontend/components';
import styles from './PhoneVerificationButton.module.css';

export const PhoneVerificationButton = (props: Partial<ButtonProps>) => (
    <Button as="span" className={styles.verificationButton} color="normal" size="s" {...props}>
        Подтвердить номер через sms
    </Button>
);
